// extracted by mini-css-extract-plugin
export default {"menuItemLink":"Layout_menuItemLink__rS4Z-","selectedItem":"Layout_selectedItem__yHFpz"};